var map = {
	"./arcos/bg.png": 6872,
	"./iprovinay/bg.png": 3314,
	"./juarez/bg.png": 6288,
	"./migob/bg.png": 2549,
	"./navojoa/bg.png": 5866,
	"./nayarit/bg.png": 4002,
	"./oaxaca/bg.png": 4791,
	"./repuve/bg.png": 3606,
	"./tlajomulco/bg.png": 6021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3201;